import React from "react";
import { toggle } from "../../../util/common";
import CreditHistoryCreditorContactInfoSingle from "./CreditHistoryCreditorContactInfoSingle";
import { ICreditorInfo } from "../../../store/credit/types";
import { useTranslation } from "react-i18next";
interface IProps {
    data?: ICreditorInfo[];
}
const CreditHistoryCreditorContactInfo: React.FunctionComponent<IProps> = (props) => {
    const { t: tLang } = useTranslation();
    let transUnionList = null;
    let equifaxList = null;
    let experianList = null;
    if (props.data != null) {
        transUnionList = props.data.filter((it) => it.bureau === "TransUnion");
        equifaxList = props.data.filter((it) => it.bureau === "Equifax");
        experianList = props.data.filter((it) => it.bureau === "Experian");
    }

    return (
        <React.Fragment>
            <div className="drawer-container">
                <div className="drawer-header">
                    <button
                        aria-expanded="false"
                        className="btn-default btn-toggle btn-drawer"
                        id="btn-creditor-contact-info"
                        onClick={() => toggle("creditor-contact-info", "btn-creditor-contact-info")}
                    >
                        <span className="btn-toggle-status sr-only">Show</span>
                        <span className="btn-text">{tLang("credit.creditReport.tabs.creditSummarySection.creditHistorySection.creditorContanctInfoSection.title")}</span>
                    </button>
                </div>

                <div className="drawer-content" id="creditor-contact-info" style={{ display: "none" }}>
                    {transUnionList != null && transUnionList.length > 0 ? <CreditHistoryCreditorContactInfoSingle data={transUnionList} /> : ""}

                    {equifaxList != null && equifaxList.length > 0 ? <CreditHistoryCreditorContactInfoSingle data={equifaxList} /> : ""}

                    {experianList != null && experianList.length > 0 ? <CreditHistoryCreditorContactInfoSingle data={experianList} /> : ""}
                </div>
            </div>
        </React.Fragment>
    );
};

export default CreditHistoryCreditorContactInfo;
